import { render, staticRenderFns } from "./EditAlarm.vue?vue&type=template&id=490503a5"
import script from "./EditAlarm.vue?vue&type=script&lang=js"
export * from "./EditAlarm.vue?vue&type=script&lang=js"
import style0 from "./EditAlarm.vue?vue&type=style&index=0&id=490503a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports